import type { PostgrestError } from '@supabase/supabase-js';
import { apiPost, type ApiMethod } from '@/integrations/api/client';
import { supabase } from '@/integrations/supabase/client';
import type { WriteResult } from '@/shared/lib/store-write';

async function send(
  accessToken: () => Promise<string | null>,
  path: string,
  body: Record<string, unknown>,
  method: ApiMethod,
): Promise<WriteResult> {
  try {
    return await apiPost(accessToken, path, body, method);
  } catch (error) {
    return {
      data: null,
      error: {
        name: 'ApiError',
        code: 'unreachable',
        message: error instanceof Error ? error.message : 'The server could not be reached.',
        details: '',
        hint: '',
      } as PostgrestError,
    };
  }
}

export function coreApi(
  path: string,
  body: Record<string, unknown> = {},
  method: ApiMethod = 'POST',
): Promise<WriteResult> {
  return send(async () => (await supabase.auth.getSession()).data.session?.access_token ?? null, path, body, method);
}

export function coreApiAs(
  accessToken: string | null | undefined,
  path: string,
  body: Record<string, unknown> = {},
  method: ApiMethod = 'POST',
): Promise<WriteResult> {
  if (!accessToken) return coreApi(path, body, method);
  return send(async () => accessToken, path, body, method);
}
